/* eslint-disable prettier/prettier */
import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/components/controlVariations/DropdownFilter.module.css';

interface Option {
	label: string;
	value: string | number;
}

interface DropdownFilterProps {
	placeholder: string;
	options: Option[];
	onSelect: (value: string | number) => void;
	selectedValue?: string | number;
}

const DropdownFilter: React.FC<DropdownFilterProps> = ({
	placeholder,
	options,
	onSelect,
	selectedValue,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const currentLabel =
		options.find(opt => opt.value === selectedValue)?.label || placeholder;

	return (
		<div className={styles.dropdownWrapper} ref={dropdownRef}>
			<button
				type="button"
				className={`${styles.dropdownButton} ${isOpen ? styles.active : ''}`}
				onClick={() => setIsOpen(!isOpen)}
			>
				<span className={styles.label}>{currentLabel}</span>
				<svg
					className={`${styles.chevron} ${isOpen ? styles.rotate : ''}`}
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<path d="M6 9l6 6 6-6" />
				</svg>
			</button>

			{isOpen && (
				<ul className={styles.menu}>
					{options.map(option => (
						<li
							key={option.value}
							className={styles.menuItem}
							onClick={() => {
								onSelect(option.value);
								setIsOpen(false);
							}}
						>
							{option.label}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default DropdownFilter;
